<template>
  <div class="vx-card p-6">
    <h1 class="text-center mb-4">Müşteri Create Raporu</h1>
    <div class="items-center">
      <!-- ITEMS PER PAGE -->

      <div class="vx-row">
        <div class="vx-col md:w-1/4">
          <label><b>Başlangıç</b></label>
          <DatePicker v-model="searchModel.startDate" valueType="format" class="w-full"></DatePicker>
        </div>

        <div class="vx-col md:w-1/4">
          <label><b>Bitiş</b></label>
          <DatePicker v-model="searchModel.finishDate" valueType="format" class="w-full" @change="customerReport()"></DatePicker>
        </div>

        <div class="vx-col md:w-1/4 mt-3">
          <vs-button size="" type="border" color="warning" @click="customerReport()">Görüntüle</vs-button>
        </div>

        <div class="vx-col md:w-1/4 mt-4">
          <div style="cursor: pointer; width: 150px; margin-left: -200px;" class="flex items-center">
            <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
            <JsonExcel :data="personnels" class>Raporu Kaydet</JsonExcel>
          </div>
        </div>
      </div>

      <div class="vx-row mt-12">
        <vs-table search noDataText="Rapor Bulunamadı!" :data="personnels" :pagination="true" :maxItems="7" class="w-full">
          <template slot="thead">
            <vs-th style="width: 30px;">Yıl</vs-th>
            <vs-th style="width: 30px;">Ay</vs-th>
            <vs-th style="width: 30px;">Personel</vs-th>
            <vs-th style="width: 30px;">Toplam Kayıt</vs-th>
            <vs-th style="width: 30px;">Toplam Kvkk </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, i) in data" :key="i">
              <vs-td>{{ tr.year }}</vs-td>
              <vs-td>{{ tr.month }}</vs-td>
              <vs-td>{{ tr.personnel }}</vs-td>
              <vs-td>{{ tr.count }}</vs-td>
              <vs-td>{{ tr.kvkkCount }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    vSelect,
    JsonExcel,
  },
  data() {
    return {
      personnels: [],
      searchModel: {},
      year: [],
      selectedYear: 0,
      month: [],
      selectedMonth: 0,
    };
  },
  created() {},
  methods: {
    customerReport: async function () {
      this.personnels = await repository.postEntity("Reports/GetCreatedCustomerReport", this.searchModel).then((r) => r.list);
    },
  },
};
</script>
